/**
 * Regexp matching all object's IDs in url
 */
export const IDENTIFIER = /\d+\w+-.+|\d+/;
